import { Component, OnInit } from '@angular/core';

import { SessionService } from '@app/core/services/session.service';

import { Dealer } from '@app/core/models/dealer.model';

import { DomainHelper } from '@app/core/helpers/domain.helper';

@Component({
	selector: 'cng-privacy-policy',
	templateUrl: './privacy-policy.component.html',
	styleUrls: ['../legal-info.less'],
})
export class ConfigurePrivacyPolicyComponent implements OnInit {
	dealer: Dealer = this.session_service.getDealer();
	domain: string = 'https://' + DomainHelper.getDomain();

	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {SessionService} session_service
	 */
	constructor(private session_service: SessionService) {}

	/**
	 * Lifecycle hook: Stops app loading and sets <title> tag.
	 */
	ngOnInit(): void {
		this.session_service.stopAppLoading();
		this.session_service.setTitle('Privacy Policy');
	}
}
